import { CaseStudy } from '../../types';
import { WHISTLEROLL_HERO } from '../../assets/images';

export const whistleroll: CaseStudy = {
  id: '12',
  title: 'WhistleRoll',
  category: 'School Sports Attendance & Tracking',
  imageUrl: WHISTLEROLL_HERO,
  description: 'Precision on the sidelines. WhistleRoll is the essential school sports attendance and athlete tracking platform for teachers, coaches, and sports coordinators. Replace paper registers with rapid digital check-ins, real-time safety rosters, and seamless team management across training sessions, fixtures, and athletic tours.',
  screenshots: [
    'https://images.unsplash.com/photo-1526232761682-d26e03ac148e?q=80&w=800&auto=format&fit=crop',
    'https://images.unsplash.com/photo-1574629810360-7efbbe195018?q=80&w=800&auto=format&fit=crop'
  ],
  comingSoon: true
};
